const awsAmplify = {
  Auth: {
    identityPoolId: process.env.VUE_APP_IDENTITY_POOL_ID,
    region: process.env.VUE_APP_AWS_REGION,
    userPoolId: process.env.VUE_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_USER_POOL_CLIENT_ID
  },
  Storage: {
    AWSS3: {
      bucket: process.env.VUE_APP_S3_BUCKET,
      region: process.env.VUE_APP_AWS_REGION
    }
  }
};

export default awsAmplify;
